import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faList, faSlidersUp, faPercent } from '@fortawesome/pro-regular-svg-icons';

export type BoardingTabId = 'services' | 'rates' | 'rate_rules';

export interface BoardingTab {
    id: BoardingTabId;
    name: string;
    icon: IconDefinition;
}

export const servicesTab: BoardingTab = {
    id: 'services',
    name: 'Services',
    icon: faList
};

export const ratesTab: BoardingTab = {
    id: 'rates',
    name: 'Rates',
    icon: faPercent
};

export const rateRulesTab: BoardingTab = {
    id: 'rate_rules',
    name: 'Rate Rules',
    icon: faSlidersUp
};

export const boardingTabs = [servicesTab, ratesTab, rateRulesTab];
